export enum ErrorType {
    HasBeenThrown = 'errorHasBeenThrown',
}

export interface ErrorHasBeenThrownAction {
    type: ErrorType.HasBeenThrown;
    error: Error;
}

export const errorHasBeenThrown = (error: Error): ErrorHasBeenThrownAction => ({
    type: ErrorType.HasBeenThrown,
    error,
});

export type ErrorActionTypes = ErrorHasBeenThrownAction;
